"use client";

import Link from "next/link";
import Image from "next/image";
import { motion } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SITE } from "@/lib/constants";

export function AboutCta() {
  return (
    <section className="relative overflow-hidden py-20 md:py-28">
      <Image
        src="/images/champagne-cheers-hills.jpg"
        alt="Celebrate at Nest Villas"
        fill
        className="object-cover"
        sizes="100vw"
      />
      <div className="absolute inset-0 bg-background/85" />
      <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/80 to-background" />

      <div className="relative z-10 mx-auto max-w-3xl px-4 text-center md:px-8">
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mx-auto flex w-fit items-center gap-3"
        >
          <div className="h-px w-12 bg-gradient-to-r from-transparent to-primary/60 md:w-20" />
          <div className="size-1.5 rotate-45 bg-primary/80" />
          <div className="h-px w-12 bg-gradient-to-l from-transparent to-primary/60 md:w-20" />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-8 font-playfair text-2xl italic leading-relaxed text-foreground md:text-3xl lg:text-4xl"
        >
          &ldquo;Nest Villas — luxury holidays and experiences, thoughtfully
          crafted.&rdquo;
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="mt-8 text-base text-muted-foreground md:text-lg"
        >
          Begin your story at {SITE.name} — the first chapter of the Nest Villas
          collection.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4"
        >
          <Button
            asChild
            size="lg"
            className="rounded-full bg-primary px-8 font-semibold text-primary-foreground hover:bg-primary/90 gold-glow"
          >
            <Link href="/book">
              Book Your Stay
              <ArrowRight className="size-4" />
            </Link>
          </Button>
          <Button
            asChild
            variant="outline"
            size="lg"
            className="rounded-full border-border px-8 text-foreground hover:bg-secondary"
          >
            <a
              href={`https://wa.me/${SITE.phone.replace(/[^0-9]/g, "")}?text=Hi%2C%20I%27d%20like%20to%20know%20more%20about%20Nest%20Villas`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <MessageCircle className="size-4" />
              Talk to Us
            </a>
          </Button>
        </motion.div>
      </div>
    </section>
  );
}
